import { TableStructure } from "../components/TableStructure";

const TvcMinutes = [
  {
    fileStoreId: "1d05ea66-4558-44c7-9187-37473e47f7e4",
    label:
      "Minutes of the meeting of Town Vending Committee (TVC) for Kolkata City, held on 12.02.2026 in the Conference Room-I, KMC",
  },
  {
    fileStoreId: "95abe9e7-c65c-4284-82aa-457feda1d77c",
    label:
      "Minutes of the meeting of Town Vending Committee (TVC) for Kolkata City, held on 16.09.2025 in the Conference Room-I, KMC",
  },
  {
    fileStoreId: "9ab8c9af-657e-4f32-aad1-aa5fb483cba6",
    label:
      "Minutes of the meeting of Town Vending Committee (TVC) for Kolkata City, held on 23.07.2025 in the Conference Room-I, KMC",
  },
  {
    fileStoreId: "c355a49f-be9a-4887-8b26-189d1937007f",
    label:
      "Minutes of the meeting of Town Vending Committee (TVC) for Kolkata City, held on 15.07.2025 in the Conference Room-I, KMC",
  },
  {
    fileStoreId: "aa85838b-1487-420f-879b-d7cc1adee08b",
    label:
      "Minutes of the meeting of Town Vending Committee (TVC) for Kolkata City, held on 04.06.2025 in the Conference Room-I, KMC",
  },
  {
    fileStoreId: "034a9cf5-0d5b-4c54-9967-541849377190",
    label:
      "Minutes of the meeting of Town Vending Committee (TVC) for Kolkata City, held on 16.04.2025 in the Conference Room-I, KMC",
  },
  {
    fileStoreId: "fbb914c6-e143-4997-9553-66dc10c9e7f3",
    label:
      "Minutes of the meeting of Town Vending Committee (TVC) for Kolkata City, held on 24.03.2025 in the Conference Room-I, KMC",
  },
  {
    fileStoreId: "2a0f83c3-7cdf-4388-9de9-3d78652d5637",
    label:
      "Minutes of the meeting of Town Vending Committee (TVC) for Kolkata City, held on 30.01.2025 in the Conference Room-I, KMC",
  },
  {
    fileStoreId: "480169e4-feb9-4558-b544-8929a861276b",
    label:
      "Minutes of the meeting of Town Vending Committee (TVC) for Kolkata City, held on 28.11.2024 in the Conference Room-I, KMC",
  },
  {
    fileStoreId: "24539a61-1a1f-40a0-a75c-37bacaa9fb9f",
    label:
      "Minutes of the meeting of Town Vending Committee (TVC) for Kolkata City, held on 30.09.2024 in the Conference Room-I, KMC",
  },
  {
    fileStoreId: "d579fc42-598e-43dd-9aee-a8a63626da57",
    label:
      "Minutes of the meeting of Town Vending Committee (TVC) for Kolkata City, held on 31.07.2024 in the Conference Room-I, KMC",
  },
  {
    fileStoreId: "948536cd-0a32-400a-a07a-90dbcce3a007",
    label:
      "Minutes of the meeting of Town Vending Committee (TVC) for Kolkata City, held on 03.04.2024 in the Conference Room-I, KMC",
  },
  {
    fileStoreId: "67cf7af0-d420-43c6-8ead-bf7795f978cf",
    label:
      "Minutes of the meeting of Town Vending Committee (TVC) for Kolkata City, held on 12.03.2024 in the Conference Room-I, KMC",
  },
  {
    fileStoreId: "f975b1d9-69d3-4904-a934-8313a69b4a60",
    label:
      "Minutes of the meeting of Town Vending Committee (TVC) for Kolkata City, held on 07.02.2024 in the Conference Room-I, KMC",
  },
  {
    fileStoreId: "f0500698-25d2-4d50-9454-1050fe5cb446",
    label:
      "Minutes of the meeting of Town Vending Committee (TVC) for Kolkata City, held on 11.01.2024 in the Conference Room-I, KMC",
  },
  {
    fileStoreId: "63f2b73f-bbf4-4bf5-9c59-29affd0ec563",
    label:
      "Minutes of the meeting of Town Vending Committee (TVC) for Kolkata City, held on 20.12.2023 in the Conference Room-I, KMC",
  },
  {
    fileStoreId: "10b05bfb-c311-4225-9808-4c3c995aad0d",
    label:
      "Minutes of the meeting of Town Vending Committee (TVC) for Kolkata City, held on 04.10.2023 in the Conference Room-I, KMC",
  },
  {
    fileStoreId: "3496a731-80d4-404c-ba3c-ab0b4605763f",
    label:
      "Minutes of the meeting of Town Vending Committee (TVC) for Kolkata City, held on 11.08.2023 in the Conference Room-II, KMC",
  },
  {
    fileStoreId: "027da469-4f57-4593-8839-6d29161f8f03",
    label:
      "Minutes of the meeting of Town Vending Committee (TVC) for Kolkata City, held on 07.07.2023 in the Conference Room-I, KMC",
  },
  {
    fileStoreId: "8752bc39-2193-4df5-a8b1-d63f5b894cee",
    label:
      "Minutes of the meeting of Town Vending Committee (TVC) for Kolkata City, held on 16.03.2023 in the Conference Room-I, KMC",
  },
  {
    fileStoreId: "da5e5c4d-0b3d-4539-bca0-80862b12e4fc",
    label:
      "Minutes of the meeting of Town Vending Committee (TVC) for Kolkata City, held on 01.12.2022 in the Conference Room-I, KMC",
  },
  {
    fileStoreId: "7f9192eb-796d-4828-8289-fcf1cc470207",
    label:
      "Minutes of the meeting of Town Vending Committee (TVC) for Kolkata City, held on 01.11.2022 in the Conference Room-I, KMC",
  },
  {
    fileStoreId: "5083751a-b971-4eb4-919e-c101fc594dc7",
    label: "Minutes of the meeting held at KMC on 01.06.2022",
  },
  {
    fileStoreId: "93649fd1-5641-44f6-890b-a842cae1b76f",
    label:
      "Minutes of the meeting held on 18.04.2022 at 2 PM in the Council Chamber, CMO Building, KMC in respect of Town Vending Committee",
  },
  {
    fileStoreId: "99a75992-db62-4647-98b2-2117ca825127",
    label:
      "Minutes of the meeting of Town Vending Committee (TVC) for Kolkata City, held on 23.02.2022 in the Council Chamber, KMC",
  },
  {
    fileStoreId: "52d83f2e-7de4-46b2-bfcd-36af736c0710",
    label:
      "Minutes of the meeting of Town Vending Committee (TVC) for Kolkata City, held on 14.01.2022 in the Council Chamber",
  },
  {
    fileStoreId: "6967042f-3910-4b85-b952-5ffda14fb268",
    label:
      "Minutes in the meeting of Town Vending Committee on 14.12.2018 in the Conference Room No. 1 of the CMO Buildings",
  },
  {
    fileStoreId: "8aee126d-fcda-40f8-9f41-5f3f00ab56b1",
    label:
      "Minutes of the meeting regarding the constitution of the Town Vending Committee for Kolkata city, held on 27.09.2018 in the Conference Hall 1 of the KMC",
  },
];

const Mom_tvc = () => (
  <TableStructure
    heading={"MOM - TOWN VENDING COMMITTEE"}
    list={TvcMinutes}
    leftMenuList={[
      { type: "link", to: "/Mom_tvc", label: "MOM - TVC", active: true },
    ]}
    title="MOM - TOWN VENDING COMMITTEE"
  />
);

export default Mom_tvc;
